import React from "react";
import Intro from "./home/intro";
import Missions from "./home/missions";
import LayeredPanes from "./home/layered-panes";
import FeaturedProducts from "./home/featured-products";
import SleekBase from "./home/sleek-base";
import Testimonials from "./home/testimonials";
import FeaturesGrid from "./home/features-grid";
import DarkBgPane from "./home/dark-bg-pane";
import LeaveMessage from "./home/leave-message";

const Home = () => {
  return (
    <React.Fragment>
  
  <Intro />
  <section className="white">
         <Missions />

        <LayeredPanes />
        <div className="featured-products-bg">
          <FeaturedProducts />{/**/}
        </div>
         <SleekBase /> 
        <FeaturesGrid />
        <DarkBgPane />
        <Testimonials />

        <LeaveMessage />
      </section> 
    </React.Fragment>
  );
};

export default Home;
